import { ViewStream } from "spyne";
import { AuthViewTraits } from "traits/auth-view-traits";
import UserProfileTmpl from "./templates/auth-view-profile.tmpl.html";
import { AuthViewProfileAppsList } from "components/auth/auth-view-profile-apps-list";

export class AuthViewProfile extends ViewStream {
  constructor(props = {}) {
    props.class = "auth-user-profile auth-view-state-item";
    props.traits = [AuthViewTraits];

    props.data = AuthViewTraits.authView$SetProfileData(props.data);
    //console.log('auth view profile data ',props.data);

    props.template = UserProfileTmpl;
    props.channels = ["CHANNEL_AUTH"];
    super(props);
  }

  addActionListeners() {
    return [["CHANNEL_AUTH_TOGGLE_PROFILE_EVENT", "onToggleProfile"]];
  }

  onToggleProfile(e) {
    const { toggleState } = e.payload;
    this.props.el$.toggleClass("active", toggleState);
  }

  broadcastEvents() {
    return [["button", "click"]];
  }

  onRendered() {
    if (this.props.data.userRecord !== undefined) {
      this.appendView(
        new AuthViewProfileAppsList({ data: this.props.data.userRecord }),
        ".auth-view-apps-list-container",
      );
    }
  }
}
